export default function AlertHexagonIcon(props) {
  const { stroke, ...oRest } = props
  return (
    <svg
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...oRest}
    >
      <path
        d="M12 7.94157V12M12 16.0584H12.01M3 7.88217V16.1178C3 16.4655 3 16.6393 3.05048 16.7943C3.09515 16.9315 3.16816 17.0574 3.26463 17.1636C3.37369 17.2837 3.52345 17.3681 3.82297 17.5369L11.223 21.7081C11.5066 21.8679 11.6484 21.9479 11.7985 21.9792C11.9315 22.0069 12.0685 22.0069 12.2015 21.9792C12.3516 21.9479 12.4934 21.8679 12.777 21.7081L20.177 17.5369C20.4766 17.3681 20.6263 17.2837 20.7354 17.1636C20.8318 17.0574 20.9049 16.9315 20.9495 16.7943C21 16.6393 21 16.4655 21 16.1178V7.88217C21 7.53452 21 7.36069 20.9495 7.20566C20.9049 7.06851 20.8318 6.94262 20.7354 6.8364C20.6263 6.71633 20.4766 6.63192 20.177 6.46308L12.777 2.29193C12.4934 2.13207 12.3516 2.05214 12.2015 2.0208C12.0685 1.99307 11.9315 1.99307 11.7985 2.0208C11.6484 2.05214 11.5066 2.13207 11.223 2.29193L3.82297 6.46308C3.52345 6.63192 3.37369 6.71633 3.26463 6.8364C3.16816 6.94262 3.09515 7.06851 3.05048 7.20566C3 7.36069 3 7.53452 3 7.88217Z"
        stroke={stroke || "#414A53"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

